<template>
    <div>
        <div class="page-group-title"><span>当前合同（{{contractSn}}）绑定的其他用户</span></div>
        <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-table
                    :data="dataList"
                    border
                    style="width: 100%"
                    v-loading="listLoading"
                    size="small"
                    stripe
                    class="MT10"
                >
                    <el-table-column prop="userType" label="用户身份">
                        <template slot-scope="scope">{{$userType.get(scope.row.userType)}}</template>
                    </el-table-column>
                    <el-table-column prop="userId" label="用户ID"></el-table-column>
                    <el-table-column prop="name" label="用户名称">
                        <template slot-scope="scope"><el-link @click="edit(scope.row.id)" type="primary">{{scope.row.name}}</el-link></template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props:{
        contractSn:{
            type:String,
            default:''
        },
        userId:{
            type:[String,Number],
            default:''
        }
    },
    data(){
        return{
            listLoading:'',
            dataList:null,
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/receivables/otherContractUsers",
                method: "POST",
                params: {
                    contractSn: this.contractSn,
                    userId: this.userId
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.dataList = result || [];
                    } else {
                        this.$message.error(msg || "获取绑定用户失败");
                    }
                })
                .catch(() => {
                    this.$message.error("获取绑定用户失败");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        edit(id){
            this.$router.push({
                path: `/finance/activity/receivables/manage/edit/${id}`,
            });
        }
    }
}
</script>